import React from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../store/global';
import { useTranslation } from 'react-i18next'
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  let location = useLocation();
  const { openModal, hasRegistered, user } = useGlobalContext();
  const handleModal = () => {
    openModal('suggestion', true);
  };

  return (
    <footer>
      {location.pathname === "/profile/edit" && (!user?.subscriptionActive || user?.shouldUpdateProfile) && (
        <div className='footer-overlay'></div>
      )}
      <div className="logo-wrapper">
        <div className="hyatt icon-HYATT"></div>
        <div className="ideas icon-IDEAS2-1"></div>
      </div>
      <div className="suggestions">
        <p>
          {t('Have_Suggestions_For_Improvements')}
          <br />
          <span onClick={handleModal}>{t('Give_Us_Your_Ideas')}</span>
        </p>
      </div>
      <Link to="/terms" className="discover-style">
        {t('Terms_And_Conditions')}
      </Link>
    </footer>
  );
};

export default Footer;
